import * as React from "react";

export const WhatAppIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(({ className, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2663.07 1105.54"
    fill="currentColor"
    className={className}
    {...props}
  >
    <path d="M1117.42,426.72l-153.6,440h-205.6s-63.2-188.8-65.6-210.4c-.8-8-5.6-48.8-5.6-48.8,0,0-5.6,40-6.4,48-1.6,22.4-64,211.2-64,211.2h-208l-152-440h186.4l78.4,280,71.2-280h199.2l72.8,280,74.4-280h178.4Z" />
    <path d="M1591.82,866.72h-185.6c-4.8,0-4.8-5.6-4.8-243.2,0-41.6-22.4-64-67.2-64-48,0-74.4,30.4-74.4,67.2v240h-182.4V229.11h178.4v258.4c22.4-47.2,79.2-71.2,161.6-71.2,108.8,0,167.2,57.6,167.2,174.4,0,271.2,1.6,276,7.2,276Z" />
    <path d="M2407,568.32h-105.6v132.8c0,29.6,14.4,40,49.6,40,17.6,0,36.8-2.4,51.2-5.6v124c-24.8,8-75.2,13.6-129.6,13.6-73.6,0-155.2-31.2-155.2-136.8v-168h-59.2v-141.6h57.6c3.2-15.2,4.8-96,4.8-96h177.6v96h108.8v141.6Z" />
    <path d="M2084.86,765.92c0-38.4,0-87.2.8-112.8,1.6-39.2-1.6-87.2-7.2-112-16.8-77.6-94.4-125.6-236.8-125.6-116.8,0-198.4,24-240,94.4-12.8,21.6-20,52-20.8,72.8h173.6c.8-9.6,7.2-20,17.6-29.6,12.8-11.2,33.6-15.2,63.2-15.2,35.2,0,57.6,11.2,65.6,29.6,4.8,11.2,5.6,19.2,6.4,30.4-40-4-76.8-5.6-111.2-4.8-160.8,5.6-232.8,62.4-237.6,134.4-.8,12-.8,28.8-.8,34.4,4,76.8,76,110.4,173.6,110.4,87.2,0,148.8-16,181.6-43.2,0,18.4,4.8,37.6,8,37.6h173.6c-8-10.4-9.6-60-9.6-100.8ZM1875.14,691.82c-.36,18.69-11.31,35.64-28.3,43.57l19.85,62.5h-84.92s20.46-63.94,20.46-63.94c-15.72-8.76-25.52-25.53-25.26-43.5.26-26.57,21.58-48.06,48.19-48.56,7.85-.21,15.69,1.64,22.82,5.16,16.96,8.43,27.52,26,27.16,44.77Z" />
  </svg>
));
WhatAppIcon.displayName = "WhatAppIcon";
